import type { ReactElement } from 'react';
import { allMasteryDescriptors, masteryFromSortOrder } from '@/lib/mastery';
import { cn } from '@/lib/cn';

export type MasteryLevelSelectorProps = {
  value: number | null | undefined;
  onChange: (sortOrder: number) => void;
  disabled?: boolean;
  className?: string;
};

export function MasteryLevelSelector({
  value,
  onChange,
  disabled = false,
  className,
}: MasteryLevelSelectorProps): ReactElement {
  const currentSortOrder = value == null ? null : masteryFromSortOrder(value).sortOrder;

  return (
    <div className={cn('grid grid-cols-2 gap-2 sm:grid-cols-3', className)}>
      {allMasteryDescriptors().map((descriptor) => {
        const isActive = descriptor.sortOrder === currentSortOrder;
        return (
          <button
            key={descriptor.sortOrder}
            type="button"
            aria-pressed={isActive}
            disabled={disabled}
            onClick={() => onChange(descriptor.sortOrder)}
            className={cn(
              'flex h-14 flex-col items-center justify-center rounded-xl border text-xs font-bold transition-all',
              'focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]',
              'disabled:cursor-not-allowed disabled:opacity-50',
              isActive
                ? 'border-[var(--brand)] bg-[var(--brand)] text-white shadow-md shadow-[color:var(--brand)]/20'
                : 'border-[var(--rule)] bg-[var(--bg-surface)] text-[var(--ink)] hover:border-[var(--brand)]',
            )}
          >
            <span>{descriptor.shortLabel}</span>
          </button>
        );
      })}
    </div>
  );
}
